import React from 'react';
import { ArrowRightIcon, ActivityIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden" data-id="element-146">
      {/* Background Effects */}
      <div className="absolute inset-0 w-full h-full bg-[#0a0a1a] -z-20" data-id="element-147"></div>
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-600/20 rounded-full blur-[120px] -z-10" data-id="element-148"></div>
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-cyan-600/20 rounded-full blur-[120px] -z-10" data-id="element-149"></div>
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-[0.03] -z-10" data-id="element-150"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-151">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 backdrop-blur-sm mb-8" data-id="element-152">
          <span className="flex h-2 w-2 rounded-full bg-cyan-400 animate-pulse" data-id="element-153"></span>
          <span className="text-sm font-medium text-slate-300" data-id="element-154">
            Next-Gen Australian Financial Strategies
          </span>
        </div>

        <h1 className="text-5xl md:text-7xl font-bold tracking-tight text-white mb-6 leading-tight" data-id="element-155">
          Scale Your Wealth With <br className="hidden md:block" data-id="element-156" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-cyan-400 to-teal-400" data-id="element-157">
            Data-Driven Precision
          </span>
        </h1>

        <p className="mt-4 text-xl text-slate-400 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-158">
          Empowering Australians to optimize cash flow, minimize tax, and
          accelerate wealth creation through intelligent financial modeling and
          expert advisory.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-159">
          <a href="#tools" className="w-full sm:w-auto px-8 py-4 rounded-xl bg-gradient-to-r from-blue-600 to-cyan-600 text-white font-semibold text-lg hover:shadow-[0_0_30px_rgba(59,130,246,0.4)] transition-all flex items-center justify-center gap-2 group" data-id="element-160">
            <ActivityIcon className="w-5 h-5 group-hover:animate-bounce" data-id="element-161" />
            Explore Interactive Tools
          </a>
          <a href="#contact" className="w-full sm:w-auto px-8 py-4 rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 text-white font-semibold text-lg backdrop-blur-sm transition-all flex items-center justify-center gap-2 group" data-id="element-162">
            Book Free Consultation
            <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-163" />
          </a>
        </div>
      </div>
    </section>;
}